var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAureconLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 83,
    height: 20,
    viewBox: "0 0 1125 323",
    style: {
      enableBackground: "new 0 0 1125 323"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7AB800",
    d: "M139.6,39.7c0,27.2,0.3,37-10.4,47.9c-7.9,8.1-21.8,10.9-32,7.1c-3.4-1.2-6.6-3.2-9.2-5.9 C77.5,78,78.7,59.3,89.3,48.5c13.2-13.6,31-12.9,50.3-12.9L139.6,39.7L139.6,39.7z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65.5,
    y: 35.5,
    fill: "none",
    width: 991.6,
    height: 219.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M327.6,240.3c11.5,6.9,28.6,10.9,42.8,10.6l0-142.6h-46.8l0,94c-7.5,6.1-18.4,10-26.9,10 c-11.5-0.2-13.7-6.3-14.1-17.8v-86.2h-46.8v86.2v7.7c0,15.6,3.5,28.8,11.3,38.1c7.8,9.4,19.7,14.5,35.6,14.5 C298.4,254.8,313.4,250.3,327.6,240.3L327.6,240.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M436.6,118.9c-11.5-6.9-28.6-10.9-42.8-10.6v142.5h46.8l0.1-94.1c6-5.8,18.2-10.7,34.7-9.7l9-41.4 C460,103,441.9,115,436.6,118.9L436.6,118.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M834.1,216.9c-19.3,0-24.7-17-24.9-38c0.2-20.5,6.4-36.8,25.8-36.8c19.3,0,24.7,16.5,24.9,37.4 C859.6,200,853.4,216.8,834.1,216.9L834.1,216.9z M835.5,104.4c-47,0.1-74.4,32.1-74.5,74.8c0,21.5,5.7,40.4,17.7,53.9 c12.1,13.5,30.3,21.5,54.8,21.5c47-0.1,74.4-32.2,74.5-74.8c0-21.5-5.7-40.4-17.7-53.9C878.3,112.3,859.9,104.3,835.5,104.4 L835.5,104.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M965.3,118.6c-11.5-6.9-28.6-10.9-42.8-10.6v142.6h46.8l0-94c7.5-6.1,18.4-10,26.9-10 c11.5,0.2,13.7,6.3,14.1,17.8v86.2h46.8v-86.2v-7.7c0-15.6-3.5-28.8-11.3-38.1c-7.8-9.4-19.7-14.5-35.6-14.5 C994.5,104.1,979.6,108.7,965.3,118.6L965.3,118.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M556.6,141.2c12.6,0,18.9,9.8,19.7,20.5h-42.8C536.1,150.2,544.4,141.2,556.6,141.2L556.6,141.2z M567.1,216.6 c-15.8-0.2-29.9-8.5-34.1-23.7h89.3v-14c0-20.1-2.8-40.3-17.6-56c-10.9-11.8-26.9-18.9-45.6-18.8c-44.7,0.1-75.6,30.1-75.7,75.1 c0,23.2,7.3,42.1,20.6,55.2c13.3,13.1,32.3,20.2,55.4,20.2c26.1,0,46.7-7.1,61.6-13l-9.8-33.4C591.2,214.3,576,216.7,567.1,216.6 L567.1,216.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M713.9,217.1c-18.4-0.2-29.8-12.5-30-37.7c0.2-23.8,10.9-36.9,32-37.1c7.4,0,16,1.4,33.2,8.5l7.9-36.1 c0,0-20.1-10.4-46.4-10.4c-23,0-41.8,7.5-54.8,21.1c-13,13.5-20,32.9-20,56.3c0,22.8,6.8,41.2,19.2,53.7 c12.5,12.6,30.5,19.2,52.5,19.2h0.2c15,0,29.8-1.4,52-11.7c-1.9-6.3-7.9-26.4-10.3-34.4C738.4,213.3,725.9,217.3,713.9,217.1 L713.9,217.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M162.2,202.5c-7.9,8.2-21.8,10.9-32,7.1c-3.4-1.2-6.6-3.2-9.2-5.9c-10.5-10.8-9.3-29.5,1.3-40.3 c13.2-13.6,31-12.9,50.3-12.9l0,4.1C172.6,181.8,172.9,191.5,162.2,202.5L162.2,202.5z M225.8,250.3c-12.2-14.5-13.3-34.7-13.3-49.7 l-0.1-92.4h-61.6c-25.2,0-48.4,7.6-65.2,24.5c-12.4,12.5-19.6,30.7-20.1,48.7c-0.1,3.1,0,3.5,0,3.7c0.2,19.4,7,37.8,20.1,51.1 C98,248.8,114.9,255,133.1,255h4.3c14.9,0,29.8-4.1,45.5-15c11.4,7,28.6,11.1,42.8,10.8V250.3L225.8,250.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAureconLogoBlack);
export default __webpack_public_path__ + "static/media/aurecon_logo_black.9976503f3ea23ac482a0f8507ba1e2a7.svg";
export { ForwardRef as ReactComponent };